import { UserComponent } from '@craftjs/core';
import { FormFieldProps, FormFieldWithScoreProps } from './BaseControlTypes';
import { SliderColorSchemeEnum } from 'src/components/uikit/inputs/slider/appSliderInput';
import { createId } from 'src/helpers/typeUtils';

export type SliderInputProps = FormFieldProps &
  FormFieldWithScoreProps & {
    isSkipped?: boolean;
    hasSkipCheckBox?: boolean;
    minValue: number;
    maxValue: number;
    captionStartText?: string;
    captionCenterText?: string;
    captionEndText?: string;
    colorScheme: SliderColorSchemeEnum;
    step?: number;
    hideMarks?: boolean;
    marksStep?: number;
    startPoint?: number;
    showNumberInput?: boolean;
  };

export const sliderInputDefaultProps: SliderInputProps = {
  dataKey: createId(),
  title: 'Form slider input',
  minValue: 0,
  maxValue: 10,
  colorScheme: SliderColorSchemeEnum.SingleColor,
  step: 1,
  marksStep: 1,
};

export type FormSliderInputComponent = UserComponent<SliderInputProps>;
